import type { HelpBlock } from '../../help/types';

function Block({ block }: { block: HelpBlock }) {
  switch (block.kind) {
    case 'para':
      return (
        <p
          style={{
            fontSize: 14,
            lineHeight: 1.55,
            margin: '6px 0',
            color: block.tone === 'muted' ? 'var(--text-muted)' : undefined,
          }}
        >
          {block.text}
        </p>
      );
    case 'callout':
      return (
        <div
          style={{
            border: `1px solid ${block.variant === 'warn' ? 'var(--warning, #d97706)' : 'var(--brand)'}`,
            background:
              block.variant === 'warn' ? 'var(--warning-bg, #fff8e1)' : 'rgba(192,0,0,0.05)',
            borderRadius: 8,
            padding: '10px 12px',
            fontSize: 13,
            margin: '8px 0',
          }}
        >
          {block.text}
        </div>
      );
    case 'bullets':
      return (
        <ul style={{ margin: '6px 0', paddingLeft: 20, fontSize: 14 }}>
          {block.items.map((it, i) => (
            <li key={i} style={{ marginBottom: 3 }}>
              {it.lead && <b>{it.lead}</b>}
              {it.text}
            </li>
          ))}
        </ul>
      );
    case 'steps':
      return (
        <ol style={{ margin: '6px 0', paddingLeft: 20, fontSize: 14 }}>
          {block.items.map((it, i) => (
            <li key={i} style={{ marginBottom: 3 }}>
              <b>{it.title}</b>
              {it.text ? ` — ${it.text}` : ''}
            </li>
          ))}
        </ol>
      );
    case 'image':
      return (
        <figure style={{ margin: '10px 0' }}>
          <img
            src={block.src}
            alt={block.caption ?? ''}
            loading="lazy"
            style={{ width: '100%', borderRadius: 8, border: '1px solid var(--border)' }}
          />
          {block.caption && (
            <figcaption
              className="meta"
              style={{ fontSize: 12, marginTop: 4, textAlign: 'center' }}
            >
              {block.caption}
            </figcaption>
          )}
        </figure>
      );
    case 'table':
      return (
        <table className="tbl" style={{ width: '100%', margin: '8px 0', fontSize: 13 }}>
          <thead>
            <tr>
              {block.head.map((h, i) => (
                <th key={i}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {block.rows.map((r, i) => (
              <tr key={i}>
                {r.map((c, j) => (
                  <td key={j}>{c}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      );
    default: {
      // Compile-time exhaustiveness: a new HelpBlock kind must be handled above.
      const _exhaustive: never = block;
      return _exhaustive;
    }
  }
}

export function HelpBlocks({ blocks }: { blocks: HelpBlock[] }) {
  return (
    <>
      {blocks.map((b, i) => (
        <Block key={i} block={b} />
      ))}
    </>
  );
}
